import(/* webpackMode: "eager" */ "/opt/app/meet/app/page.tsx");
